// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import { type APIPromise, APIResource, type FetchParams } from "../../core";

import type {
  Attributes,
  Member,
  MembershipStatus,
  Metadata,
  Problem,
} from "../../types";
export type ListMerchantMembersQueryParams = {
  offset?: number;
  limit?: number;
  scroll?: boolean;
  email?: string;
  "user.id"?: string;
  status?: MembershipStatus;
  roles?: string[];
};

export type ListMerchantMembersResponse = {
  items: Member[];
  total_count?: number;
};

export type CreateMerchantMemberParams = {
  /**
   * True if the user is managed by the merchant. In this case, we'll created a virtual user with the provided password and nickname.
   */
  is_managed_user?: boolean;
  /**
   * Email address of the member to add.
   */
  email: string;
  /**
   * Password of the member to add. Only used if `is_managed_user` is true. In the case of service accounts, the password is not used and can not be defined by the caller.
   */
  password?: string;
  /**
   * Nickname of the member to add. Only used if `is_managed_user` is true. Used for display purposes only.
   */
  nickname?: string;
  /**
   * List of roles to assign to the new member.
   */
  roles: string[];
  metadata?: Metadata;
  attributes?: Attributes;
};

export type UpdateMerchantMemberParams = {
  roles?: string[];
  metadata?: Metadata;
  attributes?: Attributes;
  /**
   * Allows you to update user data of managed users.
   */
  user?: {
    /**
     * User's preferred name. Used for display purposes only.
     */
    nickname?: string;
    /**
     * Password of the member to add. Only used if `is_managed_user` is true.
     */
    password?: string;
  };
};

export class Members extends APIResource {
  /**
   * Lists merchant members.
   */
  list(
    merchantCode: string,
    query?: ListMerchantMembersQueryParams,
    params?: FetchParams,
  ): APIPromise<ListMerchantMembersResponse, Problem> {
    return this._client.get<ListMerchantMembersResponse, Problem>({
      path: `/v0.1/merchants/${merchantCode}/members`,
      query,
      ...params,
    });
  }

  /**
   * Create a merchant member.
   */
  create(
    merchantCode: string,
    body: CreateMerchantMemberParams,
    params?: FetchParams,
  ): APIPromise<Member, Problem> {
    return this._client.post<Member, Problem>({
      path: `/v0.1/merchants/${merchantCode}/members`,
      body,
      ...params,
    });
  }

  /**
   * Retrieve a merchant member.
   */
  get(
    merchantCode: string,
    memberId: string,
    params?: FetchParams,
  ): APIPromise<Member, Problem> {
    return this._client.get<Member, Problem>({
      path: `/v0.1/merchants/${merchantCode}/members/${memberId}`,
      ...params,
    });
  }

  /**
   * Update the merchant member.
   */
  update(
    merchantCode: string,
    memberId: string,
    body: UpdateMerchantMemberParams,
    params?: FetchParams,
  ): APIPromise<Member, Problem> {
    return this._client.put<Member, Problem>({
      path: `/v0.1/merchants/${merchantCode}/members/${memberId}`,
      body,
      ...params,
    });
  }

  /**
   * Deletes a merchant member.
   */
  delete(
    merchantCode: string,
    memberId: string,
    params?: FetchParams,
  ): APIPromise<void, Problem> {
    return this._client.delete<void, Problem>({
      path: `/v0.1/merchants/${merchantCode}/members/${memberId}`,
      ...params,
    });
  }
}
